import { AUTHEN } from 'constants/authoriz'
import axios, { AxiosResponse, AxiosError, Method } from 'axios'

const fetch = (
  method: Method,
  endpoint = '/',
  data = {},
  headers = {},
  apiUrl = process.env.REACT_APP_API_URL,
  options = {},
) => {
  const url = `${apiUrl}${endpoint}`
  const queryName = method === 'GET' ? 'params' : 'data'
  const api = axios.create({
    baseURL: url,
  })

  api.interceptors.request.use((config: any) => {
    const accessToken = localStorage.getItem(AUTHEN.AUTHEN_TOKEN)
    if (accessToken) {
      config.headers['Authorization'] = `Bearer ${accessToken}`
    }

    config.headers['Key'] = process.env.REACT_APP_API_KEY
    return config
  })

  return api
    .request({
      method,
      url,
      [queryName]: data,
      headers: {
        Accept: 'application/json',
        'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
        ...headers,
      },
      ...options,
    })
    .then((response: AxiosResponse) => {
      return response.data
    })
    .catch((error: AxiosError) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // return Promise.reject(error.response.data)
        return Promise.reject(error.response.data)
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.error('error.request', error.request)
      } else {
        // Something happened in setting up the request that triggered an Error
        return Promise.reject({
          error: {
            description: error.message,
          },
        })
      }
    })
}

export default fetch
